import { lazy, Suspense, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

import { TIcons } from '.';
import { type Isvg } from '../../assets/icons/svg.interface';
import { Theme } from '@mui/material';

export interface IconProps extends Omit<Isvg, 'color'> {
  name: TIcons;
  color?: ((theme: Theme) => string) | 'white' | 'inherit' | 'primary' | (string & {});
}

export const Icon = ({ name, width, height, color }: IconProps) => {
  const theme = useTheme();

  let iconColor = '';
  if (typeof color === 'function') {
    iconColor = color(theme);
  } else {
    switch (true) {
      case color === 'inherit':
        iconColor = 'currentColor';
        break;
      case color === 'white':
        iconColor = theme.palette.common.white;
        break;
      case color !== undefined:
        iconColor = color as string;
        break;
      default:
        iconColor = theme.palette.grey[200];
    }
    if (color === 'primary') {
      iconColor = theme.palette.primary.main;
    }
  }

  const TheIcon = useMemo(
    () =>
      lazy(() =>
        import(`../../assets/icons/${name?.toLowerCase?.()}.tsx`).catch(() =>
          import(`../../assets/icons/${name}.tsx`).catch(err => {
            console.warn('missing state icon: ', err);
            return {
              default: () => null
            };
          })
        )
      ),
    [name]
  );

  return (
    <Suspense fallback={<span />}>
      <TheIcon width={width} height={height} color={iconColor} />
    </Suspense>
  );
};

export default Icon;
